import {RouterView} from '../RouterView'
const Public = _ => import(/* webpackChunkName: "js/split/Public", webpackPreload: true */ '@/components/views/panel/publicAccess/Home');
const PublicDashboard = _ => import(/* webpackChunkName: "js/split/PublicDashboard", webpackPreload: true */ '@/components/views/panel/publicAccess/partials/PublicDashboard');
const NotFound = _ => import(/* webpackChunkName: "js/split/NotFound", webpackPreload: true */ '@/components/views/panel/partials/NotFound');
const Acquisition = _ => import(/* webpackChunkName: "js/split/Acquisition", webpackPreload: true */ '@/components/views/registers/partials/publicRequest');
const Create = _ => import(/* webpackChunkName: "js/split/Create", webpackPreload: true */ '@/components/views/registers/partials/Create');
const PublicInbox = _ => import(/* webpackChunkName: "js/split/PublicInbox", webpackPreload: true */ '@/components/views/registers/partials/publicInbox');
const Profile = _ => import(/* webpackChunkName: "js/split/Profile", webpackPreload: true */ '@/components/partials/Profile')
export default {
    path: '/solicitudes',
    component: PublicDashboard,
    meta:{
        auth: true
    },
    children: [
        {
            path: '',
            component: Public,
            meta:{
                auth: true
            },
        },
        {
            path: 'adquisiciones',
            component: Acquisition,
            meta: {
                auth: true
            }
        },
        {
            path: 'fideicomisos',
            component: Acquisition,
            meta: {
                auth: true
            }
        },
        {
            path: 'convenios',
            component: Acquisition,
            meta: {
                auth: true
            }
        },
        {
            path: 'registro',
            component: Create,
            meta: {
                auth: true
            }
        },
        {
            path: 'consulta',
            component: PublicInbox,
            meta: {
                auth: true
            }
        },
        {
            path: 'perfil',
            component: Profile,
            meta: {
                auth: true
            }
        },

    ],
}
